<template>
  <div class="about">
    <h1>Impressum</h1>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: "About",
}
</script>
